import { Card } from '@/components/common/card'
import { Separator } from '@/components/common/separator'
import { Tooltip, TooltipContent } from '@/components/common/tooltip'
import { HelpIcon } from '@/components/icons/help'
import { ShieldIcon } from '@/components/icons/shield'
import { SupportDollarIcon } from '@/components/icons/supportDollar'
import { cn } from '@/utils/cn'

interface Props {
  className?: string
}

export const SafetyPanel = ({ className }: Props) => {
  return (
    <Card
      className={cn(
        'relative isolate flex items-center justify-between gap-x-5 overflow-hidden bg-surface p-4',
        'after:-z-10 after:pointer-events-none after:absolute after:inset-0 after:bg-[-40%_10%] after:bg-[radial-gradient(ellipse_at_10%_40%,transparent_38%,#0DA2FF_65%,#0073FF)] after:bg-[size:135%_340%] after:[mask-image:linear-gradient(to_right,transparent_25%,black)]',
        className
      )}
    >
      <div className="flex-1 whitespace-nowrap">
        <div className="flex items-center gap-0.5">
          <ShieldIcon size={20} className="text-accent" />
          <h6 className="font-medium text-heading-foreground text-sm">Security</h6>
        </div>
        <p className="mt-1.5 text-xs">No extra contracts</p>
      </div>

      <Separator orientation="vertical" className="h-12 transition-all group-data-[state=open]:h-9" />

      <div className="flex-1 whitespace-nowrap">
        <div className="flex items-center gap-0.5">
          <SupportDollarIcon size={20} className="text-accent" />
          <h6 className="font-medium text-heading-foreground text-sm">Cost</h6>
        </div>
        <p className="mt-1.5 text-xs">Zero fees from us</p>
      </div>
      <p className="sr-only">{panelDescription}</p>
      <Tooltip className="absolute top-4 right-4 text-active-foreground" tabIndex={-1}>
        <HelpIcon size={16} />
        <TooltipContent className="max-w-[42ch]">
          <p>{panelDescription}</p>
        </TooltipContent>
      </Tooltip>
    </Card>
  )
}

const panelDescription =
  'Vaults.fyi prepares identical transactions as the official protocol interface, with no added fees.'
